import {ScrollProvider} from "./components/Scroll/Scroll";
import BackTop from "./pages/components/BackTop/BackTop";
import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import './lang';
import {REACT_APP_NODE_ENV} from "./constants/env";
import {disableReactDevTools} from "@fvilers/disable-react-devtools";
import HomePage from "./pages/Home/HomePage";
import Login from "./pages/Login/Login";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {getUserByToken} from "./store/slices/userSlice";
import FullLoading from "./components/LoadingComponents/FullLoading";
import MonitoringPage from "./pages/Monitoring/MonitoringPage";
import NewsPage from "./pages/News/NewsPage";
import NewsDetailPage from "./pages/News/NewsDetailPage";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import WaterAnalysisPage from "./pages/WaterAnalysis/WaterAnalysisPage";
import WeatherMapPage from "./pages/WeatherMap/WeatherMapPage";
import TeamPage from "./pages/Team/TeamPage";

if (REACT_APP_NODE_ENV === 'production') {
    disableReactDevTools();
}
function App() {

    const {user, isLoading} = useSelector(state => state.user);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getUserByToken());
    }, []);

    if (isLoading) {
        return <FullLoading/>;
    }

    return (
        <ScrollProvider>
            <BackTop/>
            {/*<LanguageButton/>*/}
            {/*<WhatsAppButton/>*/}
            <Router>
                <Routes>
                    <Route path='/' element={<HomePage/>}/>
                    <Route path='/dashboard' element={<DashboardPage/>}/>
                    <Route path='/monitoring' element={
                        <ProtectedRoute requiredRole="admin">
                            <MonitoringPage/>
                        </ProtectedRoute>
                    }/>
                    <Route path='/news' element={<NewsPage/>}/>
                    <Route path='/news/:id' element={<NewsDetailPage/>}/>
                    <Route path='/water-analysis' element={<WaterAnalysisPage/>}/>
                    <Route path='/weather-map' element={<WeatherMapPage/>}/>
                    <Route path='/team' element={<TeamPage/>}/>
                    <Route path='/login' element={<Login/>}/>
                </Routes>
            </Router>
        </ScrollProvider>
    );
}

export default App;
